import { IndustryConfig } from '../../../types'

export const professionalServicesConfig: IndustryConfig = {
  id: 'professional-services',
  name: 'Professional Services',
  icon: '📊',
  description: 'Consulting, legal, accounting, and professional service firms',
  
  businessTypes: [
    {
      id: 'consulting-firm',
      name: 'Consulting Firm',
      description: 'Management, strategy, and business consulting'
    },
    {
      id: 'legal-services',
      name: 'Legal Services',
      description: 'Law firms and legal service providers'
    },
    {
      id: 'accounting-finance',
      name: 'Accounting & Finance',
      description: 'CPA firms and financial service providers'
    },
    {
      id: 'technical-services',
      name: 'Technical Services',
      description: 'Engineering, IT, and technical consulting'
    }
  ],
  
  revenueStreamTypes: [
    {
      id: 'billable-hours',
      name: 'Billable Hours',
      description: 'Time-based professional service revenue',
      intelligenceValue: "We'll monitor billing rate trends, utilization patterns, and market pricing in your practice areas."
    },
    {
      id: 'project-based',
      name: 'Project-Based Revenue',
      description: 'Fixed-price project and engagement revenue',
      intelligenceValue: "We'll track project scope trends, competitive bidding, and project profitability benchmarks."
    },
    {
      id: 'retainer-contracts',
      name: 'Retainer Contracts',
      description: 'Ongoing retainer and subscription revenue',
      intelligenceValue: "We'll monitor client retention trends, retainer pricing, and service delivery models."
    }
  ],
  
  supplierCategories: [
    {
      id: 'technology-systems',
      name: 'Technology Systems',
      suppliers: ['Practice Management Software', 'Document Management', 'Research Platforms', 'Communication Tools'],
      spendRanges: ['Under $10K', '$10K-$50K', '$50K-$150K', 'Over $150K']
    },
    {
      id: 'professional-development',
      name: 'Professional Development',
      suppliers: ['Training Providers', 'Certification Programs', 'Conference Organizations', 'Professional Associations'],
      spendRanges: ['Under $5K', '$5K-$25K', '$25K-$75K', 'Over $75K']
    },
    {
      id: 'business-services',
      name: 'Business Services',
      suppliers: ['Marketing Services', 'Business Development', 'Administrative Services', 'Office Services'],
      spendRanges: ['Under $15K', '$15K-$50K', '$50K-$150K', 'Over $150K']
    }
  ],
  
  competitiveFactors: [
    'Professional expertise',
    'Client relationships',
    'Industry reputation',
    'Service quality',
    'Response time',
    'Cost competitiveness',
    'Technology capabilities',
    'Geographic presence'
  ]
}